export default {"src":"/_next/static/media/java.31c00271.svg","height":346,"width":256,"blurWidth":0,"blurHeight":0};